import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SideNavComponent } from '../shared/side-nav/side-nav.component';
import { TopNavComponent } from '../shared/top-nav/top-nav.component';
import {
  ProposalModalComponent,
  ProposalData,
} from '../shared/components/proposal-modal/proposal-modal.component';

@Component({
  selector: 'app-employee-detail',
  standalone: true,
  imports: [
    TopNavComponent,
    SideNavComponent,
    CommonModule,
    ProposalModalComponent,
  ],
  templateUrl: './employee-detail.component.html',
  styleUrl: './employee-detail.component.scss',
})
export class EmployeeDetailComponent {
  isProposalModalOpen = false;
  candidateName = 'Inés Néstor';
  employeeId: string = '';

  constructor(private router: Router, private route: ActivatedRoute) {
    // Get employee ID from route params
    this.route.params.subscribe((params) => {
      this.employeeId = params['id'] || '1';
    });
  }

  openProposalModal() {
    this.isProposalModalOpen = true;
  }

  closeProposalModal() {
    this.isProposalModalOpen = false;
  }

  navigateToReview() {
    this.router.navigate(['/employee', this.employeeId, 'review']);
  }

  onProposalSubmit(proposalData: ProposalData) {
    console.log('Proposal submitted:', proposalData);
    // Aquí puedes implementar la lógica para enviar la propuesta
    // Por ejemplo, llamar a un servicio para guardar la propuesta
    alert(
      `Proposal submitted for ${this.candidateName}:\nJob: ${proposalData.job}\nReason: ${proposalData.reason}`
    );
    this.closeProposalModal();
  }
}
